import { StrapiImageAsset } from "@/components/StrapiImageAsset";
import { basierCirleBold } from "@/styles/fonts";
import theme from "@/styles/theme";
import { CardActionArea } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "next/link";

export const BandFriend = ({ received = false, band }) => {
  return (
    <CardActionArea
      sx={{
        transition: "0.25s ease-in-out",
        "&:hover": {
          transform: "translateY(-.625rem)",
          boxShadow: "rgb(88, 85, 102) 0px 30px 30px -20px",
          "& .genre-location": {
            color: theme.palette.primary.main,
          },
        },
      }}
      component={Link}
      href={`/musik/${band.slug}`}
    >
      <Box
        sx={{
          p: 2,
          position: "relative",
          color: theme.palette.common.white,
          [theme.breakpoints.up("sm")]: {},
        }}
      >
        {received && (
          <Box
            sx={{
              zIndex: "500",
              position: "absolute",
              top: "0",
              right: "0",
              height: "calc(1.125rem + 2px)",
              width: "calc(1.125rem + 2px)",
              backgroundColor: theme.palette.primary.main,
              borderRadius: "50%",
              transform: "translate(0.5rem, -0.5rem)",
              border: `2px solid ${theme.palette.common.white}`,
            }}
          />
        )}
        <StrapiImageAsset
          strapiImageObject={band.photo}
          layout="fill"
          width={320}
          height={180}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(0deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.6) 100%)",
          }}
        ></Box>
        <Grid
          container
          justifyContent="center"
          alignItems="flex-end"
          sx={{ position: "relative", minHeight: "147px" }}
        >
          <Grid item xs={12} sx={{ height: "100%" }}>
            <Grid container alignItems="center">
              <Grid
                item
                xs="auto"
                sx={{
                  position: "relative",
                }}
              ></Grid>
              <Grid
                item
                xs={12}
                sx={{
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    textTransform: "uppercase",
                    fontSize: "1.125rem",
                    lineHeight: "1.2",
                    fontWeight: basierCirleBold.style.fontWeight,
                    fontFamily: basierCirleBold.style.fontFamily,
                    mb: 0.5,
                    [theme.breakpoints.up("sm")]: {
                      fontSize: "1.375rem",
                    },
                  }}
                >
                  {band.name}
                </Typography>
                <Typography
                  variant="body2"
                  className="genre-location"
                  sx={{
                    transition: "0.25s ease-in-out",
                    color: theme.palette.secondary.main,
                    [theme.breakpoints.only("xs")]: {
                      fontSize: ".9375rem",
                    },
                  }}
                >
                  {band?.genre_description || band?.genres[0]?.title}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </CardActionArea>
  );
};
